import DemoMaterialTileImage from 'app/components/requestType/DemoMaterialTileImage'
import PriceChangeTileImage from 'app/components/requestType/PriceChangeTileImage'
import { ROUTES } from 'app/routes/types'
import React from 'react'

export type RequestTypeOptionConfig = {
  route: ROUTES
  labelKey: string
  iconBg: string
  Icon: React.ComponentType<{ size?: number }>
}

export const REQUEST_TYPE_CONFIG: Record<string, RequestTypeOptionConfig> = {
  PRICE_CHANGE: {
    route: ROUTES.PRICE_REQUEST,
    labelKey: 'change_selling_price',
    iconBg: '#f4f1d0',
    Icon: PriceChangeTileImage,
  },
  DEMO_MATERIAL_ISSUANCE: {
    route: ROUTES.DEMO_MATERIAL_REQUEST,
    labelKey: 'demo_material_issue',
    iconBg: '#e7f3ff',
    Icon: DemoMaterialTileImage,
  },
}
